const menuItems = [];

menuItems["Home"] = [{
    icon: "mdi-home",
    text: "Domov",
    to: "/"
}];

menuItems["Skode"] = [{
        icon: "mdi-grid",
        text: "Spisek",
        to: "/skode"
    },
    {
        icon: "mdi-file-plus-outline",
        text: "Nova",
        to: "/skode/nova"
    },
    {
        icon: "mdi-file-pdf-outline",
        text: "Poročilo",
        to: "/skode/report"
    },
];

menuItems["About"] = [{
    icon: "mdi-information-outline",
    text: "O programu",
    to: "/about"
}, ];

menuItems["Settings"] = [{
    icon: "mdi-cog",
    text: "Osnovne nastavitve",
    to: "/nastavitve"
}, ];

export default menuItems;
